import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TopActionMenus from "./TopActionMenus";
import { NavigationLink } from "navigation-react";

const DashboardMainContent = ({
  AddTitle = "",
  className = "",
  ctscaniconImage,
  ctscaniconLable = "",
  ctscanstateKey = "",
  xrayiconImage,
  xrayiconLable = "",
  xraystateKey = "",
  ultrasoundiconImage,
  ultrasoundiconLable = "",
  ultrasoundstateKey = "",
  ctScanonClick,
}) => {
  return (
    <div className="main-content-wrapper">
      <TopActionMenus AddTitle={AddTitle} />
      <main className="main-content">
        <button
          className={className}
          id="ct-scan"
          stateKey={ctscanstateKey}
          onClick={ctScanonClick}
        >
          <FontAwesomeIcon icon={ctscaniconImage} /> {ctscaniconLable}
        </button>

        <NavigationLink
          className={className}
          id="x-ray"
          stateKey={xraystateKey}
        >
          <FontAwesomeIcon icon={xrayiconImage} /> {xrayiconLable}
        </NavigationLink>
        <NavigationLink
          className={className}
          id="ultrasound"
          stateKey={ultrasoundstateKey}
        >
          <FontAwesomeIcon icon={ultrasoundiconImage} /> {ultrasoundiconLable}
        </NavigationLink>
      </main>
    </div>
  );
};

export default DashboardMainContent;
